export default {
  init() {
    $(window).load(function(){

      require('bigtext')

      $('h2.card-title').bigtext({'maxfontsize': 64});

    });
  },
};



// WEBPACK FOOTER //
// ./scripts/templates/templateLanding.js